module.exports = "/_next/static/pages/about/Fragments/66e2cedf0f556c086d838eb94d0a1d95.jpg";